export default __webpack_public_path__ + "static/media/step_E_UA.c47d930b.png";